const lang = {
    'first-stop': '首站',
    'taoyuan-taiwan': '桃園',
    'announcement': 'GoShare 移動共享服務於桃園正式營運！',
    'description': '* 詳細營運地區請參考 GoShare App',
};

export default lang;
